import store from '@/store'
import PollingManager from './polling-manager'

const POLLING_TASK_KEYS = Object.freeze({
  PLATFORM_STATUS: 'platform-status',
})

const POLLING_TASKS = [
  {
    key: POLLING_TASK_KEYS.PLATFORM_STATUS,
    interval: 60 * 1000,
    handler: () => store.dispatch('home/getAllPlatforms', { force: true }),
  },
]

const pollingManager = new PollingManager()
let initialized = false
let unwatchAuthStatus = null

function cleanupAuthStatusWatcher() {
  if (unwatchAuthStatus) {
    unwatchAuthStatus()
    unwatchAuthStatus = null
  }
}

function registerPollingTasks() {
  POLLING_TASKS.forEach(task => {
    pollingManager.register(task)
  })
}

function syncPollingTasksWithAuthStatus(isLoggedIn) {
  if (isLoggedIn) {
    pollingManager.startAll()
    return
  }

  pollingManager.stopAll()
}

export function ensurePollingTasksInitialized() {
  if (!initialized) {
    registerPollingTasks()
    initialized = true
  }

  cleanupAuthStatusWatcher()
  unwatchAuthStatus = store.watch(
    state => state.auth.isLoggedIn,
    isLoggedIn => {
      syncPollingTasksWithAuthStatus(isLoggedIn)
    }
  )

  syncPollingTasksWithAuthStatus(store.state.auth.isLoggedIn)
  return pollingManager
}

export function refreshPlatformStatus() {
  if (!initialized) {
    registerPollingTasks()
    initialized = true
  }

  return pollingManager.run(POLLING_TASK_KEYS.PLATFORM_STATUS)
}

export function stopPollingTasks() {
  pollingManager.stopAll()
}

export default pollingManager
